import { Module } from 'wrapper6';
import $ from 'jquery';

export default class LazyImages extends Module {

    ready(){
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("Trident");

        if (msie > 0) {
            LazyImages.ieResolve();
            return true;
        }

        LazyImages.resolveLazyLoad(document.querySelectorAll('[critical]'));
        LazyImages.resolveLazyLoad(document.querySelectorAll('[data-lazy-load]'));
        window.addEventListener("scroll", () => LazyImages.resolveLazyLoad(document.querySelectorAll('[data-lazy-load]')));
    }

    static isScrolledIntoView(elem) {
        let docViewTop = window.scrollY;
        let elemTop = elem.getBoundingClientRect().top + document.body.scrollTop - 1000;

        return (elemTop <= docViewTop);
    }

    static ieResolve() {
        let lazyElements = document.querySelectorAll('[data-lazy-load]');

        Array.prototype.forEach.call(lazyElements, function (item) {
            const fullSize = $(item).attr('data-full') ? item.getAttribute('data-full') : item.getAttribute('src');

            let preload = new Image();

            preload.onload = () => {
                item.setAttribute('src', fullSize);
                item.removeAttribute('data-lazy-load');
            };

            preload.src = fullSize;
        });
    }

    static resolveLazyLoad(lazyElements) {
        Array.prototype.forEach.call(lazyElements, function(item){
            if(LazyImages.isScrolledIntoView(item) && item.getAttribute('data-lazy-loaded') === 'false') {
                const fullSize = $(item).attr('data-full') ? item.getAttribute('data-full') : item.getAttribute('src');

                if (fullSize) {
                    let preload = new Image();

                    preload.onload = () => {
                        item.setAttribute('src', fullSize);
                    };

                    preload.src = fullSize;
                }

                item.setAttribute('data-lazy-loaded', 'true');
            }
        });
    }

}